import * as React from "react";
import { useLocation, useLink } from "@grandvisionhq/frk-routing";
import { createSlotsContext } from "@grandvisionhq/slots";
import { useSelector } from "@grandvisionhq/state";
import { useGetQueryParams, appendQueryParamToUrl } from "@grandvisionhq/utils";
import { ShippingObjectTypes } from "../../../../state.js";
import { getSelectedShippingMethod, getShippingData } from "../../../../StepShipping/StepShipping/selectors.js";
import { ShippingSummarySlotTypes } from "./types.js";
import { isPickupStore, isPickupPoint } from "../../../../utils/utils/shipping-method.js";
const [SummarySlotsProvider, useBaseSummarySlot] = createSlotsContext({
  displayName: "SummarySlotsContext"
});
const useSummariesSlot = (isEditable = false) => {
  const { cartId, cartHash } = useGetQueryParams();
  const { push } = useLocation();
  const selectedShippingMethod = useSelector(getSelectedShippingMethod)?.method;
  const isPickup = isPickupStore(selectedShippingMethod) || isPickupPoint(selectedShippingMethod);
  const { Slots } = useBaseSummarySlot();
  const shippingData = useSelector(getShippingData);
  const { href: shippingPageHref } = useLink({ route: "checkout.shipping" }) || {};
  const goToShippingStep = React.useCallback(
    () => shippingPageHref && push(
      appendQueryParamToUrl(shippingPageHref, {
        ...typeof cartId === "string" ? { cartId } : {},
        ...typeof cartHash === "string" ? { cartHash } : {}
      })
    ),
    [shippingPageHref, push, cartId, cartHash]
  );
  const onEdit = React.useCallback(() => {
    goToShippingStep?.();
  }, [goToShippingStep]);
  const actions = { onEdit };
  const summaries = Object.entries(Slots).reduce((summaryItem, [key, Slot]) => {
    let summaryData = shippingData && shippingData[key];
    if (shippingData && key === ShippingObjectTypes.ContactDetails) {
      const { firstName, lastName } = shippingData[ShippingObjectTypes.BillingAddress];
      summaryData = {
        firstName,
        lastName,
        ...summaryData
      };
    }
    if (key === ShippingSummarySlotTypes.Addresses) {
      summaryData = {};
      summaryData.billingAddress = shippingData?.billingAddress;
      summaryData.deliveryAddress = shippingData?.deliveryAddress;
      if (!shippingData?.deliveryAddress) {
        summaryData.isAddressesEqual = true;
      } else {
        summaryData.isAddressesEqual = false;
      }
      if (isPickup) {
        summaryData.isPickupOrder = true;
      } else {
        summaryData.isPickupOrder = false;
      }
    }
    summaryItem[key] = /* @__PURE__ */ React.createElement(
      Slot,
      {
        "data-t": `${key}Summary`,
        actions: isEditable ? actions : void 0,
        values: summaryData
      }
    );
    return summaryItem;
  }, {});
  return summaries;
};
export {
  SummarySlotsProvider,
  useBaseSummarySlot,
  useSummariesSlot
};
//# sourceMappingURL=summary-context.js.map
